import script from "./RouletteBetBoardCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./RouletteBetBoardCarousel.vue?vue&type=script&setup=true&lang=js"

import "./RouletteBetBoardCarousel.vue?vue&type=style&index=0&id=79d2c5f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d2c5f0"]])

export default __exports__